import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

const PaymentCancel = () => {
  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="payment-cancel-page">
      <div className="page-container text-center py-24">
        <XCircle className="w-16 h-16 text-muted-foreground mx-auto mb-6" strokeWidth={1} />
        <h1 className="text-3xl md:text-4xl font-heading font-light mb-4">
          Paiement annulé
        </h1>
        <p className="text-muted-foreground font-light max-w-md mx-auto mb-8">
          Votre paiement a été annulé. Si vous avez rencontré un problème, n'hésitez pas à me contacter.
        </p>
        <div className="flex gap-4 justify-center">
          <Link to="/shop">
            <Button className="btn-primary">
              Retour à la boutique
            </Button>
          </Link>
          <Link to="/contact">
            <Button className="btn-secondary">
              Me contacter
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
